import React, { useState } from 'react'
import { AccordionCard } from 'components/AccordionCard'
import { Box, Button, Flex, Modal, Text, useAppTheme } from '@workwhile/ui'
import {
  DayforceWebhookEventTypes,
  DayforceWebhookStatus,
} from 'pages/Dayforce/constants'
import { useDayforceWebhookDetailContextValue } from 'pages/Dayforce/DayforceWebhookDetail/context/DayforceWebhookDetailProvider'
import { formatInTimeZone } from 'date-fns-tz'
import { getLocalTimezone } from 'lib/time'
import { PayloadRenderer } from 'pages/Dayforce/shared/components/PayloadRenderer'

const ViewPayloadButton = () => {
  const [showPayload, setShowPayload] = useState(false)
  const {
    state: { data },
  } = useDayforceWebhookDetailContextValue()

  return (
    <Flex gap={2} justifyContent="flex-start">
      <Button
        variant="secondary"
        kind="text"
        onClick={() => setShowPayload(!showPayload)}
      >
        View payload
      </Button>
      {showPayload ? (
        <Modal open onClose={() => setShowPayload(false)}>
          <PayloadRenderer payload={data.payloadBase64} />
        </Modal>
      ) : null}
    </Flex>
  )
}

export const GeneralDetails = ({
  detailsBlock,
  actionsBlock,
}: {
  detailsBlock?: React.ReactNode
  actionsBlock?: React.ReactNode
}) => {
  const { space } = useAppTheme()

  const {
    state: { data },
  } = useDayforceWebhookDetailContextValue()

  const createdAtDay = formatInTimeZone(
    data.createdAt,
    getLocalTimezone(),
    'EEEE, MMMM d, h:mm a z'
  )
  const updatedAtDay = formatInTimeZone(
    data.updatedAt,
    getLocalTimezone(),
    'EEEE, MMMM d, h:mm a z'
  )

  return (
    <Flex gap={3} flexWrap="wrap" flexDirection="row">
      <Box style={{ flex: 1 }}>
        <AccordionCard
          title="Webhook details"
          size="large"
          contentWrapperProps={{
            display: 'flex',
            flexDirection: 'column',
            gap: space[2],
          }}
        >
          <Text>
            Event type:{' '}
            {DayforceWebhookEventTypes[data.eventType] ?? data.eventType}
          </Text>
          <Text>
            Status: {DayforceWebhookStatus[data.status] ?? data.status}
          </Text>
          <Text>Received at: {createdAtDay}</Text>
          <Text>Updated at: {updatedAtDay}</Text>
          {detailsBlock}
          <ViewPayloadButton />
        </AccordionCard>
      </Box>
      <Box>
        <AccordionCard
          title="Actions"
          size="large"
          contentWrapperProps={{
            display: 'flex',
            flexDirection: 'column',
            gap: space[2],
          }}
        >
          {actionsBlock}
        </AccordionCard>
      </Box>
    </Flex>
  )
}
